import React from "react";

const ContactUs = () => {

  const addressLines = [
    "B-609 , Empire Business Hub",
    "Science City Road",
    "Opp Silver Radiance 2",
    "Ahmedabad 380060",
  ];

  const contactDetails = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6 mr-2 text-blue-900">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
        </svg>
      ),
      value: addressLines,
      isList: true,
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6 mr-2 text-blue-900">
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 4.5l3-1.5A2.25 2.25 0 017.5 3h0a2.25 2.25 0 012.25 2.25v1.256c0 .516-.151 1.02-.433 1.447L8.5 9.75a11.25 11.25 0 005.75 5.75l1.797-1.817c.427-.282.931-.433 1.447-.433H17.25A2.25 2.25 0 0119.5 15v.75a2.25 2.25 0 01-1.5 2.121l-3 1.5A2.25 2.25 0 0113.5 21h0A15.75 15.75 0 012.25 9.75V6a2.25 2.25 0 011.5-2.121z" />
        </svg>
      ),
      value: "+91 70164 64911",
      isList: false,
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6 mr-2 text-blue-900">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5A2.25 2.25 0 0119.5 19.5H4.5a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5H4.5A2.25 2.25 0 002.25 6.75m19.5 0l-9.75 6-9.75-6" />
        </svg>
      ),
      value: "ravinai94@gmail.com",
      isList: false,
    },
  ];

  const handleWhatsAppSend = () => {
    const nameInput = document.getElementById("name");
    const mobileInput = document.getElementById("mobile");
    const messageInput = document.getElementById("message");

    const name = nameInput?.value.trim();
    const mobile = mobileInput?.value.trim();
    const message = messageInput?.value.trim();

    // ✅ Validation
    if (!name) {
      alert("Please enter your name");
      nameInput.focus();
      return;
    }

    if (!/^[6-9]\d{9}$/.test(mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      mobileInput.focus();
      return;
    }

    const phoneNumber = "917016464911"; // WhatsApp number (with country code)
    const finalMessage = `*New Contact Request*
    Name: ${name}
    Mobile: ${mobile}
    Message: ${message}`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(finalMessage)}`;

    // ✅ Open WhatsApp
    window.open(url, "_blank");

    // ✅ Thank-you message (better UX than alert)
    setTimeout(() => {
      alert("✅ Thank you! You will be redirected to WhatsApp. Please press SEND.");
    }, 300);

    // ✅ Clear form
    nameInput.value = "";
    mobileInput.value = "";
    messageInput.value = "";
  };


  return (
    <div id="contact" className="bg-gray-100 w-full p-1 flex items-center">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-lg mx-auto md:max-w-none md:grid md:grid-cols-2 md:gap-8">

          {/* Left Side */}
          <div>
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              Contact <span className="text-blue-900">US</span>
            </h2>

            <p className="text-lg text-gray-700 mb-8">
              If you have any questions or would like to schedule a consultation with one of our real estate experts, please don't hesitate to contact us.
            </p>

            <ul className="text-lg text-gray-700">
              {contactDetails.map((item, index) => (
                <li className="flex items-start mb-4" key={index}>
                  {item.icon}
                  {item.isList ? (
                    <ul>
                      {item.value.map((line, idx) => (
                        <li key={idx}>{line}</li>
                      ))}
                    </ul>
                  ) : (
                    <span>{item.value}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Right Side – Form */}
          <div className="mt-12 sm:mt-16 md:mt-0">
            <form className="grid grid-cols-1 gap-y-6">
              <div>
                <label htmlFor="name" className="block text-lg font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="mt-1 py-3 px-4 block w-full border border-blue-900 rounded-md shadow-sm"
                />
              </div>

              <div>
                <label htmlFor="mobile" className="block text-lg font-medium text-gray-700">
                  Phone
                </label>
                <input
                  type="text"
                  id="mobile"
                  className="mt-1 py-3 px-4 block w-full border border-blue-900 rounded-md shadow-sm"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-lg font-medium text-gray-700">
                  Message
                </label>
                <textarea
                  id="message"
                  className="mt-1 py-3 px-4 block w-full h-32 resize-none border border-blue-900 rounded-md shadow-sm"
                ></textarea>
              </div>

              <div className="flex justify-center">
                <button
                type="button"
                onClick={handleWhatsAppSend}
                className="py-3 px-6 rounded-md text-white bg-blue-900 hover:bg-gray-500 shadow-sm text-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                Send Inquiry !!
              </button>

              </div>

            </form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactUs;
